import React from 'react';
import { Box } from '@marvelapp/ui';
import { SpecsPanelLabel } from '@marvelapp/ui-internal';
import PanelSwatchLong from './PanelSwatchLong';
export default function PanelColorSection(_a) {
    var label = _a.label, colors = _a.colors, wordBreak = _a.wordBreak;
    return (React.createElement(Box, { marginBottom: -3 }, colors.map(function (color, index) { return (
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(Box, { key: index, marginBottom: 20 },
        React.createElement(SpecsPanelLabel, null, label),
        React.createElement(Box, { marginTop: "4px" },
            React.createElement(PanelSwatchLong, { color: color, wordBreak: wordBreak })))); })));
}
